import { connect } from 'react-redux';
import CommonError from '../../components/tools/CommonError/CommonError';
import { setSelectedTask } from '../../actions/tools/OrdersSearchActions';

function mapStateToProps(state) {
  return {};
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedTask(selectedTask) {
      return dispatch(setSelectedTask(selectedTask));
    },
  };
};

const CommonErrorContainer = connect(mapStateToProps, mapDispatchToProps)(CommonError);

export default CommonErrorContainer;
